module.exports = __webpack_public_path__ + "static/media/payment-providers.0205fb29.jpg";